import { Link } from 'react-router-dom'

import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Collapse from '@mui/material/Collapse'
import Typography from '@mui/material/Typography'

import StockListItem, { Mode } from 'components/StockListItem'
import { numberWithCammas } from 'utils'

export default function ListItem({ data, open, onClick }) {
  return (
    <div style={{ borderBottom: theme => `1px solid ${theme.palette.divider}` }}>
      <ButtonBase
        onClick={onClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          p: 2,
        }}
      >
        <div style={{ flex: 1, textAlign: 'left' }}>
          <Typography variant="body1">{data.name}</Typography>
          <Typography sx={{ mt: 1 }} variant="caption" component="p">
            {`在庫 ${numberWithCammas(data.amount)} 個 / 計 ${numberWithCammas(data.price)} 円`}
          </Typography>
        </div>
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ButtonBase>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', mb: 1 }}>
            <Typography variant="caption" component="p" style={{ flex: 1 }}>
              条件に合致する在庫一覧（金額降順）
            </Typography>
            <Link to={`/accounts/${data.id}`} style={{ fontSize: 12 }}>
              すべて見る ＞
            </Link>
          </Box>
          <Box sx={{ border: theme => `1px solid ${theme.palette.divider}` }}>
            {data.stocks.map(x => (
              <StockListItem key={x.id} mode={Mode.ADMIN_DASHBOARD} data={x} />
            ))}
          </Box>
        </Box>
      </Collapse>
    </div>
  )
}
